import { useSyncExternalStore } from 'react';

import { bind } from 'bind-event-listener';

const EVENT_TYPE = 'dynamic-prompt-fg-changed';
const STORAGE_KEY = 'atlassian-studio-dynamic-prompt-fg';

const subscribe = (callback: () => void) => {
	return bind(window, {
		type: EVENT_TYPE,
		listener: callback,
	});
};

// Get the current state from localStorage
const getSnapshot = (): string | null => {
	return localStorage.getItem(STORAGE_KEY);
};

// Set the state in localStorage
const saveFgNameToStore = (value: string): void => {
	try {
		localStorage.setItem(STORAGE_KEY, value);
		window.dispatchEvent(new Event(EVENT_TYPE));
	} catch {
		// Silently fail
	}
};

export const useDynamicPromptFGOverride = () => {
	// eslint-disable-next-line @atlaskit/platform/ensure-use-sync-external-store-server-snapshot
	const fgNameFromStore = useSyncExternalStore(subscribe, getSnapshot);

	return { fgNameFromStore, saveFgNameToStore };
};
